import { useLayoutEffect, useState, type RefObject } from 'react';
import type { FlagTypeDef } from '../../lib/flags';

/** A flag type's icon in its colour. */
export function FlagIcon({ def, size = 16, className = '' }: { def: FlagTypeDef; size?: number; className?: string }) {
  const Icon = def.icon;
  return <Icon size={size} className={`shrink-0 ${className}`} style={{ color: def.color }} aria-hidden />;
}

/**
 * Where to put a fixed popup so it stays on screen: at (x, y), moved left to
 * fit, and above `flipAbove` when it would run off the bottom.
 */
export function useFixedPosition(ref: RefObject<HTMLElement | null>, x: number, y: number, flipAbove?: number): { left: number; top: number } {
  const [pos, setPos] = useState({ left: x, top: y });
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const w = el.offsetWidth;
    const h = el.offsetHeight;
    const left = Math.max(8, Math.min(x, window.innerWidth - w - 8));
    let top = y;
    if (top + h > window.innerHeight - 8) top = Math.max(8, (flipAbove ?? y) - h - 6);
    setPos({ left, top });
  }, [ref, x, y, flipAbove]);
  return pos;
}
